import { WidgetParent } from 'components/Widget/WidgetFromType/constants';
import WidgetFromType from 'components/Widget/WidgetFromType/WidgetFromType';
import React, { useCallback } from 'react';
import useArgumentWidgetMutations from 'routes/BudgetModule/components/BudgetProposal/Resource/Arguments/Argument/hooks/useArgumentWidgetMutations';
import {
    WidgetContent,
    WidgetT,
} from 'routes/Dashboard/components/WidgetsLayout/helpers';

type Props = {
    widget: WidgetT;
    editMode: boolean;
    setEditMode: (arg1: boolean) => void;
    lazyLoading: boolean;
    isPdfModeActivated: boolean;
    layoutId: number | null;
};
export default function ArgumentWidget({
    widget,
    editMode,
    setEditMode,
    lazyLoading, // should the content of charts load only when they are visible ?
    isPdfModeActivated,
    layoutId,
}: Props): React.ReactElement {
    const { deleteWidgetMutation, updateWidgetMutation } =
        useArgumentWidgetMutations({ isPdfModeActivated, layoutId });
    const onUpdate = useCallback(
        (arg: { widget: WidgetT; content: WidgetContent }) =>
            updateWidgetMutation.mutate(arg),
        [updateWidgetMutation],
    );

    const onDelete = useCallback(
        async () => deleteWidgetMutation.mutate(widget),
        [deleteWidgetMutation, widget],
    );

    return (
        <WidgetFromType
            widget={widget}
            widgetParent={WidgetParent.ARGUMENT}
            chartProps={{
                lazyLoading,
            }}
            isPdfModeActivated={isPdfModeActivated}
            onUpdate={onUpdate}
            editModeState={[editMode, setEditMode]}
            canEdit
            onDelete={onDelete}
        />
    );
}
